export default __webpack_public_path__ + "static/media/Niy-avatar.17eb2827.png";